export interface ILeasingPreferences {
  siteId: number;
  routingUniqueId: string;
  conversationId: number;
  desiredBedrooms: string;
  desiredBathrooms: string;
  numberOfOccupants: number;
  desiredLeaseTerms: string;
  desiredPriceRangeFrom: number;
  desiredPriceRangeTo: number;
  amenityInterests: string;
  moveInDate: string;
  hasPets?: boolean;
}

export class LeasingPreferencesModel implements ILeasingPreferences {
  siteId: number = 0;
  routingUniqueId: string = '';
  conversationId: number = 0;
  desiredBedrooms: string = '';
  desiredBathrooms: string = '';
  numberOfOccupants: number = 0;
  desiredLeaseTerms: string = '';
  desiredPriceRangeFrom: number = 0;
  desiredPriceRangeTo: number = 0;
  amenityInterests: string = '';
  moveInDate: string = '';
  hasPets?: boolean;

  constructor(data: Partial<ILeasingPreferences>) {
    if (data) {
      this.siteId = data.siteId ?? this.siteId;
      this.routingUniqueId = data.routingUniqueId ?? this.routingUniqueId;
      this.conversationId = data.conversationId ?? this.conversationId;
      this.desiredBedrooms = data.desiredBedrooms ?? this.desiredBedrooms;
      this.desiredBathrooms = data.desiredBathrooms ?? this.desiredBathrooms;
      this.numberOfOccupants = data.numberOfOccupants ?? this.numberOfOccupants;
      this.desiredLeaseTerms = data.desiredLeaseTerms ?? this.desiredLeaseTerms;
      this.desiredPriceRangeFrom = data.desiredPriceRangeFrom ?? this.desiredPriceRangeFrom;
      this.desiredPriceRangeTo = data.desiredPriceRangeTo ?? this.desiredPriceRangeTo;
      this.amenityInterests = data.amenityInterests ?? this.amenityInterests;
      this.moveInDate = data.moveInDate ?? this.moveInDate;
      this.hasPets = data.hasPets ?? this.hasPets;
    }
  }
}
